"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timepicker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));

var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));

var _utils = require("../../shared/utils");

var _Timepicker = require("./Timepicker.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

(0, _reactDatepicker.registerLocale)('en-US', _enUS.default);
(0, _reactDatepicker.setDefaultLocale)('en-US', _enUS.default);

const Timepicker = ({
  label,
  onChange,
  timeIntervals,
  date,
  width,
  disabled,
  ...props
}) => {
  const [startDate, setStartDate] = (0, _react.useState)(date);
  const [focus, setFocus] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setStartDate(date);
  }, [date]);

  const handleDateChange = date => {
    setStartDate(date);
    (0, _utils.isFunction)(onChange) && onChange(date);
  };

  const handleFocus = (0, _react.useCallback)(() => setFocus(true), []);
  const handleBlur = (0, _react.useCallback)(() => setFocus(false), []);
  (0, _react.useEffect)(() => {
    setTimeList();
  }, [focus]);
  return /*#__PURE__*/_react.default.createElement(_Timepicker.StyledTimepicker, {
    label: label,
    width: width,
    isFloat: focus || startDate !== null,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({}, props, {
    customTimeInput: /*#__PURE__*/_react.default.createElement(CustomInput, {
      value: startDate,
      onChange: setStartDate
    }),
    selected: startDate,
    onChange: handleDateChange,
    onInputClick: () => setTimeList(),
    onFocus: handleFocus,
    onBlur: handleBlur,
    locale: "en-US",
    showTimeSelect: true,
    showTimeSelectOnly: true,
    timeIntervals: timeIntervals,
    timeCaption: "Time",
    dateFormat: "hh:mm aa",
    timeFormat: "hh:mm aa",
    popperModifiers: {
      preventOverflow: {
        enabled: false,
        escapeWithReference: false,
        boundariesElement: 'scrollParent'
      },
      hide: {
        enabled: false
      },
      flip: {
        behavior: ['bottom']
      }
    },
    popperPlacement: "bottom-start"
  })));
};

exports.Timepicker = Timepicker;
Timepicker.defaultProps = {
  label: '',
  timeIntervals: 15,
  width: '118px',
  disabled: false
};
Timepicker.propTypes = {
  label: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,

  /** set date externally */
  date: _propTypes.default.instanceOf(Date),
  timeIntervals: _propTypes.default.number,
  width: _propTypes.default.string,
  disabled: _propTypes.default.bool
};

const CustomInput = ({
  value,
  onChange
}) => {
  return /*#__PURE__*/_react.default.createElement("input", {
    value: value,
    onChange: e => onChange(e.target.value)
  });
};

CustomInput.propTypes = {
  value: _propTypes.default.instanceOf(Date),
  onChange: _propTypes.default.func
};

const setTimeList = () => {
  const listItems = document.querySelectorAll('.react-datepicker__time-list-item');
  listItems.length !== 0 && listItems.forEach((item, i) => {
    if (i < listItems.length / 2) {
      !item.innerHTML.includes('AM') ? item.innerHTML += ' AM' : '';
    } else {
      !item.innerHTML.includes('PM') ? item.innerHTML += ' PM' : '';
    }
  });
};